/**
 * Informs - подписки на товары
 */

export const informs = {
    namespaced: true,
    state: () => ({
        items: [],
        ok: false,
    }),
    mutations: {
        setInforms: (state, payload) => {
            state.items = payload.items;
        },
        setOk: (state, payload) => {
            state.ok = payload;
        },
    },
    actions: {
        getInforms: async ({ commit }) => {
            let { data } = await axios.get('/ajax/informs');

            commit('setInforms', data);
        },

        addToInforms: ({ dispatch, commit }, payload) => {
            let params = {
                id: payload.id,
                agree: payload.agree,
                email: payload.email,
            };

            axios.post('/ajax/informs/add', params)
                .then(request => {
                    if (
                        typeof request.data.success != "undefined" &&
                        request.data.success
                    ) {
                        dispatch('getInforms');

                        commit('setOk', true);
    
                        setTimeout(() => {
                            commit('setOk', false);
                        }, 5000);
                    }
                });
        },

        deleteFromInforms: ({ commit, dispatch }, payload) => {
            axios.delete('/ajax/informs/delete/' + payload)
                .then(request => dispatch('getInforms'));
        },
    },
    getters: {
        count: state => state.items.length
    }
}